(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ===== STICKY HEADER ===== */
  (function () {
    var header = document.querySelector('.header');
    if (!header) return;
    var lastScroll = 0;
    var threshold = 60;
    window.addEventListener('scroll', function () {
      var current = window.scrollY;
      if (current <= threshold) { header.classList.remove('header--hidden'); return; }
      if (current > lastScroll) { header.classList.add('header--hidden'); }
      else { header.classList.remove('header--hidden'); }
      lastScroll = current;
    });
  })();

  /* ===== MOBILE NAV ===== */
  (function () {
    var burger = document.getElementById('burger');
    var nav = document.getElementById('nav');
    var overlay = document.getElementById('nav-overlay');
    var navClose = document.getElementById('nav-close');
    if (!burger || !nav) return;
    function closeNav() {
      nav.classList.remove('is-open');
      burger.classList.remove('is-active');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    burger.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      burger.classList.toggle('is-active');
      if (overlay) overlay.classList.toggle('is-open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    if (navClose) navClose.addEventListener('click', closeNav);
    if (overlay) overlay.addEventListener('click', closeNav);
  })();

  /* ===== CART DRAWER ===== */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.ETOpenCart = openCart;

  (function () {
    var cartBtn = document.getElementById('cart-btn');
    var cartClose = document.getElementById('cart-close');
    if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    if (cartClose) cartClose.addEventListener('click', closeCart);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  })();

  /* ===== TOAST ===== */
  function showToast(msg) {
    var t = document.createElement('div');
    t.className = 'toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { t.remove(); }, 300);
    }, 2500);
  }

  /* ===== CART API ===== */
  function updateCartCount(count) {
    var el = document.querySelector('.header__cart-count');
    if (!el) return;
    var btn = document.getElementById('cart-btn');
    if (btn && count > (parseInt(el.textContent, 10) || 0)) {
      btn.classList.remove('is-adding');
      void btn.offsetWidth;
      btn.classList.add('is-adding');
    }
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  }

  function renderCartDrawer(cart) {
    var body = cartDrawer ? cartDrawer.querySelector('.cart-drawer__body') : null;
    var footer = cartDrawer ? cartDrawer.querySelector('.cart-drawer__footer') : null;
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.className = 'cart-drawer__body';
      body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="btn btn--dark">Continue Shopping</a></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    body.className = 'cart-drawer__body cart-drawer__body--filled';
    var html = '';
    cart.items.forEach(function (item) {
      html += '<div class="cart-item" data-key="' + item.key + '">' +
        '<div class="cart-item__img">' + (item.image ? '<img src="' + item.image + '" alt="">' : '') + '</div>' +
        '<div class="cart-item__info">' +
          '<div class="cart-item__name">' + item.product_title + '</div>' +
          '<div class="cart-item__price">' + money(item.final_line_price) + '</div>' +
          '<div class="cart-item__qty">' +
            '<button data-act="dec" data-key="' + item.key + '">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button data-act="inc" data-key="' + item.key + '">+</button>' +
          '</div>' +
          '<button class="cart-item__remove" data-act="remove" data-key="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>';
    });
    body.innerHTML = html;
    if (footer) {
      footer.style.display = 'block';
      footer.innerHTML = '<div class="cart-drawer__subtotal"><span>Subtotal</span><span>' + money(cart.total_price) + ' USD</span></div>' +
        '<a href="/checkout" class="btn btn--primary">Checkout</a>' +
        '<a href="/cart" class="btn btn--outline">View Cart</a>';
    }
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      return cart;
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      return cart;
    });
  }

  // Delegate cart drawer line item actions
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-act]');
      if (!btn) return;
      var key = btn.dataset.key;
      var act = btn.dataset.act;
      var item = cartDrawer.querySelector('.cart-item[data-key="' + key + '"]');
      var qtyEl = item ? item.querySelector('.cart-item__qty span') : null;
      var current = qtyEl ? parseInt(qtyEl.textContent) : 1;
      if (act === 'inc') changeLine(key, current + 1);
      else if (act === 'dec') changeLine(key, Math.max(0, current - 1));
      else if (act === 'remove') changeLine(key, 0);
    });
  }

  /* ===== ADD TO CART (product form) ===== */
  (function () {
    // Meta AddToCart. Every buy button on the site posts through this handler,
    // so reporting the event here covers the main form, the mobile sticky bar
    // and the buttons further down the page in one place.
    function trackAddToCart(item, submittedQty) {
      if (!window.fbq || !item || item.status) return;
      // The response describes the whole cart line, so its quantity and total
      // already include anything added earlier. Only this add belongs here.
      var added = parseInt(submittedQty, 10) || 1;
      var unit = item.final_price != null ? item.final_price : item.price || 0;
      fbq('track', 'AddToCart', {
        content_ids: [item.sku || String(item.variant_id || item.id)],
        content_type: 'product',
        content_name: item.product_title || item.title,
        value: (unit * added) / 100,
        currency:
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      });
    }

    var forms = document.querySelectorAll('form[data-product-form]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        var data = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: data })
          .then(function (r) { return r.json(); })
          .then(function (item) {
            try { trackAddToCart(item, data.get('quantity')); } catch (err) {}
            return fetchCart();
          })
          .then(function () {
            if (btn) { btn.disabled = false; btn.textContent = original; }
            openCart();
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = original; }
            showToast('Could not add to cart');
          });
      });
    });
  })();

  /* ===== QUANTITY SELECTORS (generic +/- on a number input) ===== */
  document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var delta = parseInt(b.dataset.qty);
        var val = Math.max(1, (parseInt(input.value) || 1) + delta);
        input.value = val;
      });
    });
  });

  /* ===== MEDIA GRID CAROUSEL =====
     On mobile each row is its own endless loop: a duplicate set of tiles is
     appended so scrolling past the last one lands on the first, in either
     direction. The row drifts on its own until the visitor touches it, after
     which it stays where they leave it for the rest of the visit. The clones
     are added before the lazy-video setup runs so cloned videos still play. */
  (function () {
    var mq = window.matchMedia('(max-width: 768px)');
    var AUTO_DRIFT = false; // flip on to let the rows creep sideways on their own
    var DRIFT = 5; // px per second — a slow crawl, noticeable without pulling focus

    Array.prototype.forEach.call(document.querySelectorAll('[data-media-carousel]'), function (wrap) {
      var track = wrap.querySelector('[data-media-track]');
      var prev = wrap.querySelector('[data-media-prev]');
      var next = wrap.querySelector('[data-media-next]');
      if (!track || !prev || !next) return;

      var originals = Array.prototype.slice.call(track.children);
      if (originals.length < 3) return;

      var clones = [];
      var timer = null;
      var lastAt = 0;
      var onScreen = true; // assume visible; the observer below only narrows it
      var stopped = false;
      var touching = false;
      var moving = false;
      var wrapTimer = null;
      var settleTimer = null;

      function pitch() {
        if (originals.length > 1) return originals[1].offsetLeft - originals[0].offsetLeft;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return (track.clientWidth + gap) / 2;
      }
      function loopWidth() {
        return clones.length ? clones[0].offsetLeft - originals[0].offsetLeft : 0;
      }
      function rewrap() {
        var w = loopWidth();
        if (w <= 0) return;
        if (track.scrollLeft >= w) track.scrollLeft -= w;
        else if (track.scrollLeft < 0) track.scrollLeft += w;
      }

      function addClones() {
        if (clones.length) return;
        originals.forEach(function (el) {
          var copy = el.cloneNode(true);
          copy.setAttribute('data-media-clone', '');
          copy.setAttribute('aria-hidden', 'true');
          // The duplicate set is scenery for the loop: keep it out of the
          // tab order so it isn't announced or focused twice.
          Array.prototype.forEach.call(copy.querySelectorAll('button, a, input'), function (el2) {
            el2.setAttribute('tabindex', '-1');
          });
          clones.push(copy);
          track.appendChild(copy);
        });
      }
      function removeClones() {
        clones.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); });
        clones = [];
      }

      function tick() {
        if (stopped || !onScreen) return;
        var now = Date.now();
        var dt = (now - lastAt) / 1000;
        lastAt = now;
        if (document.hidden || dt <= 0) return;
        // Capped so a throttled or backgrounded stretch resumes instead of
        // lurching forward by however long it was away
        if (dt > 0.25) dt = 0.25;
        track.scrollLeft += DRIFT * dt;
        rewrap();
      }
      function drift() {
        if (!AUTO_DRIFT) return;
        if (stopped || timer || !onScreen || !mq.matches || !clones.length) return;
        lastAt = Date.now();
        timer = setInterval(tick, 40);
      }
      function halt() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      function stopForGood() {
        if (stopped) return;
        stopped = true;
        halt();
      }

      // The drift leaves the row part way through a tile, so anything that ends
      // the motion lands it back on a tile edge — two whole tiles, never a sliver.
      function settle() {
        var p = pitch();
        if (p <= 0) return;
        rewrap();
        var target = Math.round(track.scrollLeft / p) * p;
        if (Math.abs(target - track.scrollLeft) < 0.5) return;
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
      function settleWhenIdle() {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          if (touching || moving) { settleWhenIdle(); return; }
          settle();
        }, 260);
      }

      function go(dir) {
        stopForGood();
        var p = pitch();
        if (p <= 0) return;
        rewrap();
        var target = (Math.round(track.scrollLeft / p) + dir * 2) * p;
        // Stepping back past the first tile hops onto the duplicate set first,
        // so it scrolls into the last tile instead of hitting the edge.
        if (target < 0) {
          var w = loopWidth();
          if (w <= 0) return;
          track.scrollLeft += w;
          target += w;
        }
        // Held while the arrow's own animation runs so the idle-settle below
        // doesn't normalise a position the animation hasn't reached yet.
        moving = true;
        track.scrollTo({ left: target, behavior: 'smooth' });
        clearTimeout(wrapTimer);
        wrapTimer = setTimeout(function () {
          moving = false;
          rewrap();
        }, 800);
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      ['pointerdown', 'touchstart'].forEach(function (evt) {
        wrap.addEventListener(evt, function () {
          touching = true;
          stopForGood();
        }, { passive: true });
      });
      ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (evt) {
        document.addEventListener(evt, function () {
          if (!touching) return;
          touching = false;
          settleWhenIdle();
        }, { passive: true });
      });
      wrap.addEventListener('wheel', function () {
        stopForGood();
        settleWhenIdle();
      }, { passive: true });
      track.addEventListener('scroll', function () {
        if (stopped && !moving) settleWhenIdle();
      }, { passive: true });

      function apply() {
        if (mq.matches) {
          addClones();
          prev.hidden = false;
          next.hidden = false;
          drift();
        } else {
          halt();
          removeClones();
          track.scrollLeft = 0;
          prev.hidden = true;
          next.hidden = true;
        }
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            onScreen = e.isIntersecting;
            if (onScreen) drift(); else halt();
          });
        }, { threshold: 0.25 }).observe(wrap);
      }

      apply();
      if (mq.addEventListener) mq.addEventListener('change', apply);
      else if (mq.addListener) mq.addListener(apply);
    });
  })();

  /* ===== PRODUCT MEDIA GALLERY =====
     Slides cover images and videos alike. Every slide is in the DOM and only
     the active one is displayed, which the video player reads as an on/off
     screen change and starts or stops the clip accordingly. */
  (function () {
    var stage = document.querySelector('[data-gallery]');
    if (!stage) return;
    var slides = Array.prototype.slice.call(stage.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.product-page__thumb'));
    if (slides.length < 2) return;
    var current = 0;

    var rail = document.querySelector('.product-page__thumbnails');

    // scrollIntoView walks every scrollable ancestor, the page included, so it
    // could drag the whole document up or down to reveal a thumbnail. The rail
    // is the only thing that should move, so it is scrolled on its own.
    function centreThumb(thumb) {
      if (!rail || !thumb) return;
      var target = thumb.offsetLeft - (rail.clientWidth - thumb.offsetWidth) / 2;
      var furthest = rail.scrollWidth - rail.clientWidth;
      target = Math.max(0, Math.min(target, furthest));
      if (rail.scrollTo) rail.scrollTo({ left: target, behavior: 'smooth' });
      else rail.scrollLeft = target;
    }

    // Pull the neighbouring images down early so stepping through with the
    // arrows shows them straight away instead of after a download.
    var warmed = {};
    function warmNeighbours() {
      [current - 1, current + 1].forEach(function (offset) {
        var i = (offset + slides.length) % slides.length;
        if (warmed[i]) return;
        var img = slides[i].querySelector('img');
        if (!img) return;
        warmed[i] = true;
        new Image().src = img.currentSrc || img.src;
      });
    }

    function activate(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === current);
      });
      centreThumb(thumbs[current]);
      warmNeighbours();
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { activate(i); });
    });

    var prev = document.querySelector('[data-gallery-prev]');
    var next = document.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { activate(current - 1); });
    if (next) next.addEventListener('click', function () { activate(current + 1); });

    // Swipe left/right on the media to change slides (mobile)
    var swipeArea = stage.closest('.product-page__image') || stage;
    var startX = 0, startY = 0, tracking = false, swipedAt = 0;
    swipeArea.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      startX = t.clientX; startY = t.clientY; tracking = true;
    }, { passive: true });
    swipeArea.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX, dy = t.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        swipedAt = Date.now();
        activate(dx < 0 ? current + 1 : current - 1);
      }
    }, { passive: true });
    // A swipe across a video slide still ends in a click, which would otherwise
    // pause the clip the shopper just swiped away from.
    swipeArea.addEventListener('click', function (e) {
      if (Date.now() - swipedAt < 400) {
        e.stopPropagation();
        e.preventDefault();
      }
    }, true);

    // Ready the two images either side of the opening one so the first tap is
    // as quick as the rest.
    warmNeighbours();
  })();

  /* ===== PRODUCT CAROUSEL (mobile) ===== */
  (function () {
    var grid = document.getElementById('products-grid');
    var prev = document.getElementById('products-prev');
    var next = document.getElementById('products-next');
    var dots = document.querySelectorAll('.products__dot');
    if (!grid) return;

    function cardWidth() {
      var c = grid.querySelector('.product-card');
      return c ? c.offsetWidth + 16 : 0;
    }
    function index() {
      var w = cardWidth();
      return w ? Math.round(grid.scrollLeft / w) : 0;
    }
    function go(i) {
      var w = cardWidth();
      var max = grid.children.length - 1;
      i = Math.max(0, Math.min(i, max));
      grid.scrollTo({ left: w * i, behavior: 'smooth' });
    }
    function setDots(i) {
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.index)); }); });
    grid.addEventListener('scroll', function () {
      clearTimeout(grid._t);
      grid._t = setTimeout(function () { setDots(index()); }, 100);
    });
  })();

  /* ===== PREDICTIVE SEARCH ===== */
  (function () {
    var input = document.querySelector('[data-predictive-input]');
    var results = document.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.classList.remove('is-open'); results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { results.innerHTML = '<div class="predictive-search__item">No results</div>'; results.classList.add('is-open'); return; }
            results.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="">' : '';
              return '<a class="predictive-search__item" href="' + p.url + '">' + img + '<span class="predictive-search__name">' + p.title + '</span></a>';
            }).join('');
            results.classList.add('is-open');
          });
      }, 250);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.predictive-search')) results.classList.remove('is-open');
    });
  })();

  /* ===== LAZY VIDEO PLAYER (adaptive HLS, tap to unmute / replay) =====
     Shared by the ingredients 9:16 media frame and the media grid tiles. */
  (function () {
    // Lazily load hls.js once, shared across any videos on the page.
    var hlsState = { loading: false, cbs: [] };
    function ensureHls(cb) {
      if (window.Hls) { cb(window.Hls); return; }
      hlsState.cbs.push(cb);
      if (hlsState.loading) return;
      hlsState.loading = true;
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.17/dist/hls.min.js';
      s.onload = function () { hlsState.cbs.forEach(function (f) { f(window.Hls); }); hlsState.cbs = []; };
      s.onerror = function () { hlsState.cbs.forEach(function (f) { f(null); }); hlsState.cbs = []; };
      document.head.appendChild(s);
    }

    var players = [];
    var videos = document.querySelectorAll('[data-lazy-video]');
    Array.prototype.forEach.call(videos, function (video) {
      var frame = video.closest('.vframe');
      if (!frame) return;
      var soundBtn = frame.querySelector('[data-video-sound]');
      var centerBtn = frame.querySelector('[data-video-toggle]');
      var interacted = false;
      var loaded = false;
      var wantPlay = false;
      var shouldLoop = video.getAttribute('data-loop') === 'true';
      if (shouldLoop) video.loop = true;
      players.push(video);

      // Only one video may play out loud at a time.
      function soloAudio() {
        players.forEach(function (other) {
          if (other !== video) other.muted = true;
        });
      }

      var hlsUrl = video.getAttribute('data-hls');
      var mp4Url = video.getAttribute('data-mp4');
      var nativeHls = !!(video.canPlayType('application/vnd.apple.mpegurl') || video.canPlayType('application/x-mpegURL'));

      function tryPlay() {
        if (interacted || video.ended || !video.paused) return;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      function useMp4() {
        if (!mp4Url) return;
        video.src = mp4Url;
        video.load();
      }
      function loadSources() {
        if (loaded) return;
        loaded = true;
        video.addEventListener('canplay', function () { if (wantPlay) tryPlay(); });
        if (hlsUrl && nativeHls) {
          // Safari / iOS: adaptive HLS natively
          video.src = hlsUrl;
          video.load();
        } else if (hlsUrl) {
          // Other browsers: adaptive HLS via hls.js, fall back to MP4
          ensureHls(function (Hls) {
            if (Hls && Hls.isSupported()) {
              var h = new Hls({ maxBufferLength: 12, capLevelToPlayerSize: true });
              h.on(Hls.Events.MANIFEST_PARSED, function () { if (wantPlay) tryPlay(); });
              h.on(Hls.Events.ERROR, function (e, data) { if (data && data.fatal) { try { h.destroy(); } catch (x) {} useMp4(); } });
              h.loadSource(hlsUrl);
              h.attachMedia(video);
            } else {
              useMp4();
            }
          });
        } else {
          useMp4();
        }
      }
      function sync() {
        frame.classList.toggle('is-playing', !video.paused && !video.ended);
        frame.classList.toggle('is-ended', video.ended);
        frame.classList.toggle('is-muted', video.muted);
      }
      function togglePlay() {
        wantPlay = true;
        loadSources();
        if (!interacted) { video.muted = false; soloAudio(); interacted = true; }
        if (video.ended) { video.currentTime = 0; video.play(); }
        else if (video.paused) { video.play(); }
        else { video.pause(); }
      }

      // Lazy load + autoplay only while the video is on screen; pause when it leaves.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              wantPlay = true;
              loadSources();
              tryPlay();
            } else {
              wantPlay = false;
              if (!video.paused) video.pause();
            }
          });
        }, { threshold: 0.35 });
        io.observe(frame);
      }

      video.addEventListener('click', togglePlay);
      if (centerBtn) centerBtn.addEventListener('click', function (e) { e.stopPropagation(); togglePlay(); });
      if (soundBtn) soundBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        if (!video.muted) soloAudio();
        interacted = true;
        sync();
      });
      ['play', 'pause', 'ended', 'volumechange'].forEach(function (ev) {
        video.addEventListener(ev, sync);
      });
      sync();
    });
  })();

  /* ===== JUDGE.ME: reveal reviews section / badge only when populated ===== */
  (function () {
    function watch(el, target, hasContent) {
      if (!el || !target) return;
      function check() {
        target.classList.toggle('is-active', !!hasContent(el));
      }
      check();
      try {
        new MutationObserver(check).observe(el, {
          childList: true, subtree: true, characterData: true, attributes: true
        });
      } catch (e) {}
      [800, 2000, 4000, 8000].forEach(function (t) { setTimeout(check, t); });
    }

    // Works whether the section holds the legacy widget div or a Judge.me app block.
    function sectionHasReviews(el) {
      return el.textContent.trim().length > 0 || el.getBoundingClientRect().height > 4;
    }

    // Judge.me still renders the badge with 0 reviews; only show it once it has some.
    function badgeHasReviews(el) {
      var counted = el.querySelector('[data-number-of-reviews]');
      if (counted) return parseInt(counted.getAttribute('data-number-of-reviews'), 10) > 0;
      return !!el.querySelector('.jdgm-star');
    }

    Array.prototype.forEach.call(document.querySelectorAll('.judgeme-reviews'), function (sec) {
      var content = sec.querySelector('[data-reviews-content]') ||
        sec.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
      var prompt = sec.querySelector('[data-reviews-empty]');
      watch(content, sec, function (el) {
        var populated = sectionHasReviews(el);
        // The prompt keeps the section on screen while Judge.me has nothing to show.
        sec.classList.toggle('is-empty', !populated);
        return populated || !!prompt;
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll('.product-page__reviews-badge'), function (b) {
      watch(b, b, badgeHasReviews);
    });
  })();

  /* ===== Product accordions start collapsed on mobile ===== */
  (function () {
    if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) return;
    Array.prototype.forEach.call(
      document.querySelectorAll('.product-page__accordions details.accordion[open]'),
      function (d) { d.open = false; }
    );
  })();

  /* ===== Product description "Read more" ===== */
  (function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-desc]'), function (wrap) {
      var body = wrap.querySelector('[data-desc-body]');
      var btn = wrap.querySelector('[data-desc-toggle]');
      if (!body || !btn) return;

      function sync() {
        if (wrap.classList.contains('is-expanded')) return;
        // Only offer the toggle, and only draw the fade, when there is
        // actually more text sitting behind the clamp.
        var clipped = body.scrollHeight > body.clientHeight + 4;
        btn.hidden = !clipped;
        wrap.classList.toggle('is-clipped', clipped);
      }

      btn.addEventListener('click', function () {
        var expanded = wrap.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Read less' : 'Read more';
      });

      sync();
      window.addEventListener('resize', sync);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
      setTimeout(sync, 400);
    });
  })();

  /* ===== Shopify Forms popup: turn the close icon into a real button =====
     The app ships a bare 12x16px "x" glyph, well under the 44px minimum and
     very hard to hit on a phone. Restyle it as a labelled pill instead. */
  (function () {
    var SEL = '[aria-label="Close modal"],[aria-label="Close dialog"],[aria-label="Close"]';
    var TEASER = '[class*="_appEmbedRootTeaser_"]';

    function scope(list, suffix) {
      return list.split(',').map(function (s) {
        return TEASER + ' ' + s + (suffix || '');
      }).join(',');
    }

    function each(list, suffix) {
      return list.split(',').map(function (s) { return s + suffix; }).join(',');
    }

    var CSS =
      SEL + '{' +
      'display:inline-flex!important;align-items:center!important;justify-content:center!important;' +
      'gap:6px!important;width:auto!important;height:auto!important;min-height:40px!important;' +
      'box-sizing:border-box!important;padding:9px 15px!important;' +
      'border:1px solid rgba(0,0,0,0.18)!important;border-radius:999px!important;' +
      'background:#ffffff!important;color:#202223!important;' +
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif!important;' +
      'font-size:13px!important;font-weight:700!important;line-height:1!important;' +
      'white-space:nowrap!important;cursor:pointer!important;' +
      // touch-action stops the browser waiting to see whether the tap is the
      // start of a pan or a double tap before it releases the click.
      'touch-action:manipulation!important;' +
      'box-shadow:0 1px 4px rgba(0,0,0,0.12)!important;-webkit-tap-highlight-color:transparent;}' +
      // Without the tap highlight there is nothing to confirm the press landed.
      each(SEL, ':active') + '{background:#eef0f1!important;}' +
      each(SEL, '::after') + '{content:"Close";}' +
      each(SEL, ' svg') +
      '{width:11px!important;height:11px!important;flex:0 0 auto!important;pointer-events:none!important;}' +
      // The overlay fills the screen but does not scroll, so a tap that drifts
      // even slightly gets handed to the page underneath as a scroll and the
      // click never fires. Keeping the gesture inside the overlay fixes it.
      '[role="dialog"]{overscroll-behavior:contain!important;}' +
      // The app wraps the glyph in a corner container sized to a 12px glyph, and
      // insets it far enough that a wider pill would sit on top of the headline.
      'div:has(> ' + SEL.split(',').join('),div:has(> ') + '){' +
      'width:auto!important;height:auto!important;top:10px!important;right:10px!important;}' +
      'section:has(> div > ' + SEL.split(',').join('),section:has(> div > ') + '){' +
      'padding-top:28px!important;}' +
      // The teaser docks to the bottom-left, which is where the mobile buy bar
      // lands. --sticky-buy-offset inherits in from the page and lifts it clear
      // while that bar is up.
      '[class*="_appEmbedBottomLeft_"]{' +
      'bottom:var(--sticky-buy-offset,0px)!important;transition:bottom .25s ease;}' +
      // The teaser is a permanent fixture on every page, so it stays a small
      // pill with a bare icon close. _appEmbedRootTeaser_ is dropped from the
      // root once the full form opens, which keeps the pill above intact there.
      TEASER + ' [class*="_teaserContainer_"]{padding:8px 10px!important;gap:8px!important;}' +
      TEASER + ' [class*="_teaserHeading_"]{font-size:13px!important;line-height:1.2!important;}' +
      scope(SEL) +
      '{min-height:0!important;width:24px!important;height:24px!important;padding:0!important;' +
      'box-shadow:none!important;border-color:rgba(0,0,0,0.14)!important;}' +
      scope(SEL, '::after') + '{content:none!important;}' +
      scope(SEL, ' svg') + '{width:9px!important;height:9px!important;}';

    function inject(root) {
      if (!root || root.querySelector('[data-et-close-fix]')) return;
      var style = document.createElement('style');
      style.setAttribute('data-et-close-fix', '');
      style.textContent = CSS;
      root.appendChild(style);
    }

    // The app never locks the page while its popup is up, and its backdrop is
    // not a scroll container, so a touch anywhere on the popup is handed to the
    // page underneath as a scroll. A phone tap almost always drifts a pixel or
    // two, the gesture turns into a scroll, the click is dropped and the
    // visitor has to tap the close button again. Pinning the page removes the
    // scroll for the gesture to become. Safari ignores overflow alone, hence
    // the fixed body; the form's own card keeps overflow:auto so it can still
    // scroll itself when the keyboard shrinks the viewport.
    var locked = false;
    var lockedAt = 0;
    function syncScrollLock(root) {
      var open = !!(root && root.querySelector('[role="dialog"]'));
      if (open === locked) return;
      locked = open;
      var body = document.body;
      if (open) {
        lockedAt = window.scrollY || window.pageYOffset || 0;
        body.style.position = 'fixed';
        body.style.top = -lockedAt + 'px';
        body.style.left = '0';
        body.style.width = '100%';
        body.style.overflow = 'hidden';
      } else {
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.width = '';
        if (!document.querySelector('#cart-drawer.is-open, #nav.is-open')) {
          body.style.overflow = '';
        }
        window.scrollTo(0, lockedAt);
      }
    }

    var tries = 0;
    var timer = setInterval(function () {
      var host = document.querySelector('shopify-forms-embed');
      if (host && host.shadowRoot) {
        inject(host.shadowRoot);
        syncScrollLock(host.shadowRoot);
        try {
          // The form swaps between teaser and full steps, re-rendering its tree.
          new MutationObserver(function () {
            inject(host.shadowRoot);
            syncScrollLock(host.shadowRoot);
          }).observe(host.shadowRoot, {
            childList: true,
            subtree: true
          });
        } catch (e) {}
        clearInterval(timer);
      }
      if (++tries > 40) clearInterval(timer);
    }, 500);
  })();

  /* ===== STICKY BUY BAR =====
     Appears once the main buy area is above the viewport and steps back out
     whenever another add to cart form — the comparison table, the closing CTA
     — is on screen, so there is never a second button competing with it. */
  (function () {
    var bar = document.querySelector('[data-sticky-buy]');
    var main = document.querySelector('.product-page__form');
    if (!bar || !main) return;

    var phone = window.matchMedia('(max-width: 768px)');
    var rivals = Array.prototype.filter.call(
      document.querySelectorAll('form[data-product-form]'),
      function (form) { return !bar.contains(form); }
    );
    var footer = document.querySelector('.footer');
    var queued = false;

    function onScreen(el) {
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }

    function update() {
      queued = false;
      var show = phone.matches && main.getBoundingClientRect().bottom < 0;
      if (show && footer && onScreen(footer)) show = false;
      if (show) {
        for (var i = 0; i < rivals.length; i++) {
          if (onScreen(rivals[i])) { show = false; break; }
        }
      }
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      // Read by the Shopify Forms teaser so it rides above the bar
      document.documentElement.style.setProperty(
        '--sticky-buy-offset',
        show ? bar.offsetHeight + 8 + 'px' : '0px'
      );
    }

    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  })();

  /* ===== BEFORE/AFTER ROWS ===== */
  /* One row of pairs that scrolls under a pair of arrows. On a wide screen the
     whole set usually fits, in which case both arrows sit disabled. */
  function initBapCarousel(wrap) {
    if (wrap.dataset.bapReady) return;
    var track = wrap.querySelector('[data-bap-track]');
    var nav = wrap.querySelector('[data-bap-nav]');
    if (!track || !nav || !track.children.length) return;
    var prev = nav.querySelector('[data-bap-prev]');
    var next = nav.querySelector('[data-bap-next]');
    if (!prev || !next) return;
    wrap.dataset.bapReady = '1';

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      // A couple of pixels of slack: fractional widths mean scrollLeft rarely
      // lands exactly on either end.
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    function nudge(dir) {
      var by = step() * dir;
      if (track.scrollBy) track.scrollBy({ left: by, behavior: 'smooth' });
      else track.scrollLeft += by;
    }

    prev.addEventListener('click', function () { nudge(-1); });
    next.addEventListener('click', function () { nudge(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // Widths can settle late if a picture arrives after first paint.
    window.addEventListener('load', sync);
    sync();
  }

  function initBapCarousels() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bap-carousel]'), initBapCarousel);
  }

  /* ===== MINI BEFORE/AFTER (phones) ===== */
  /* The pairs live in one section further down the page. Rather than ask the
     merchant to upload the same images twice, the compact copy that sits
     between two accordions is cloned from that section on phones only. */
  (function () {
    var mini = document.querySelector('[data-bap-mini]');
    if (!mini) return;
    var track = mini.querySelector('[data-bap-mini-track]');
    var source = document.querySelector('.bap__track');
    if (!track || !source) return;

    var phone = window.matchMedia('(max-width: 768px)');
    var built = false;

    function build() {
      if (built || !phone.matches) return;
      var pairs = source.querySelectorAll('.bap__pair');
      if (!pairs.length) return;
      built = true;

      Array.prototype.forEach.call(pairs, function (pair) {
        var copy = pair.cloneNode(true);
        // The editor binds a block to a single node, so the duplicate must not
        // claim to be that block as well.
        copy.removeAttribute('data-shopify-editor-block');
        copy.setAttribute('aria-hidden', 'true');
        track.appendChild(copy);
      });

      var note = document.querySelector('.bap__disclaimer');
      if (note) {
        var noteCopy = note.cloneNode(true);
        noteCopy.className = 'bap-mini__disclaimer';
        noteCopy.setAttribute('aria-hidden', 'true');
        mini.appendChild(noteCopy);
      }

      // Nothing is shown until there is something to show, which keeps the
      // accordion list tidy when the pairs have no images yet.
      mini.classList.add('is-ready');
      // The row only exists now, so its arrows have to be wired after the fact.
      initBapCarousels();
    }

    build();
    if (phone.addEventListener) phone.addEventListener('change', build);
    else if (phone.addListener) phone.addListener(build);
  })();

  /* ===== INIT ===== */
  initBapCarousels();
  fetchCart();
})();
